"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Dropdown_1 = __importDefault(require("./Dropdown"));
const styled_components_1 = __importDefault(require("styled-components"));
const DropDownStyled = styled_components_1.default(Dropdown_1.default) `
    flex: 1;
    position: relative;
    .ecr-dropdown-row {
        background: white;
        cursor: pointer;
        padding: 1.7% 5%;
        &.disabled {
            cursor: not-allowed;
            opacity: 0.65;
            &:hover {
                background: unset !important;
            }
        }
    }
    .ecr-dropdown-menu {
        position: relative;
        &:after {
            content: '\\22C1';
            position: absolute;
            right: 4%;
        }
    }
    .ecr-dropdown-list {
        padding-bottom: 1vw;
        max-height: 80vh;
        overflow: auto;
        background: white;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        display: none;
        .ecr-dropdown-row:hover {
            background: #21b3f63d;
        }
    }
    &.open {
        .ecr-dropdown-menu {
            box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.33);
        }
        .ecr-dropdown-list {
            display: block;
            box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.33);
        }
    }
`;
exports.default = DropDownStyled;
//# sourceMappingURL=DropdownStyled.js.map